<template>
  <div class="max-w-[300px]" v-if="messageData">
    <div class="details-wrapper">
      {{ messageData?.text }}
    </div>
  </div>
</template>

<script>

export default {
  name: "BaseNotification",
  props: {
    messageData: {
      type: Object,
      default: () => {}
    }
  }
}
</script>